import '@babel/polyfill'
import 'intersection-observer'
import history from '@/routes/history'
import { Provider } from 'react-redux'
import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import store from '@/store'
import Root from './components/Authorized/Root'
import JobStatistical from '@/components/JobStatistical'
import { isWebview } from './variable'
import './mock'

const init_store = store(history)
window.init_store = init_store
ReactDOM.render(
  <Provider store={init_store}>
    <Router history={history}>
      <Root>
        <App />
        {!isWebview && <JobStatistical />}
      </Root>
    </Router>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
